import { common } from '../api/index'
import wx from 'weixin-js-sdk'

const is_weixn = () => {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true
    } else {
      return false
    }
}

const wxShare = (url, params) => {
    if(is_weixn()) {
        common.getShareConfigInfo({
            url: encodeURIComponent(url)
        }).then(res => {
            const { appId, nonceStr, timestamp, signature, rawString } = res.data
            if(wx) {
                wx.config({
                    debug: false,
                    appId, 
                    timestamp,
                    nonceStr,
                    signature,
                    jsApiList: [
                        'updateAppMessageShareData',
                        'onMenuShareTimeline',
                        'onMenuShareQQ'
                    ] 
                })
                wx.ready(function () {
                    let { title, link, desc, imgUrl} = params
                    if(!imgUrl.match(/https/)) {
                        imgUrl = "https://image2.bjmeishu.com/msb-image/msb/image/2023-02-23/1677141231042.jpg"
                    }
                    let shareData = {
                        title: title || '',
                        link,
                        imgUrl: imgUrl || "https://image2.bjmeishu.com/msb-image/msb/image/2023-02-23/1677141231042.jpg",
                        desc: desc || ''
                    }
                    wx.onMenuShareQQ(shareData) //QQ
                    wx.updateAppMessageShareData(shareData) // wx好友
                    wx.onMenuShareTimeline(shareData) // wx朋友圈
                })
            }
        })
    }
}

export default wxShare